import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';

import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localePy from '@angular/common/locales/es';
import localeDe from '@angular/common/locales/de';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { EnvironmentTypeEnum } from './environments/environment-type.enum';
import { appConfig } from 'app/app.config';
registerLocaleData(localeIt, 'it');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localePy, 'es');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe, 'de');

if (environment.environmentType === EnvironmentTypeEnum.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch(err => console.error(err));
